export const NotFoundPage = () => {
  return (
    <>
      <h1>not found</h1>
    </>
  );
};
